import React, { Dispatch, SetStateAction } from 'react'

import {
  LoadingContainer,
  MainHealthProcedureDetailsContainer,
  MessageError,
  SkeletonItem,
  ContentInLine,
  ContainerBottom
} from './styles'
import { ImagingTestDetailsContent } from './content'
import { ModalHeaderSkeleton } from '../ModalComponents/ModalHeader/Skeleton'
import { HealthProcedureDetails } from '~/components/healthProcedures/healthProcedureDetails'

import { IFetchImagingTestViews, IHealthProcedures, IImagingTest } from '~/interfaces'
import { useFetchImagingTest } from '~/hooks'
import { DataNotFound } from '~/components/shared'

interface ImagingTestDetailsProps {
  healthProcedure: IHealthProcedures
  showModal: boolean
  setShowModal: Dispatch<SetStateAction<boolean>>
}

export const ImagingTestDetails = ({
  showModal,
  setShowModal,
  healthProcedure
}: ImagingTestDetailsProps): JSX.Element => {
  const {
    data: imagingTest,
    isLoading,
    error
  } = useFetchImagingTest(
    { pathParams: { testId: healthProcedure.id } },
    healthProcedure.type as IFetchImagingTestViews
  )

  const renderContent = (content: IImagingTest | undefined): JSX.Element => {
    if (error)
      return (
        <MessageError>
          <DataNotFound text={error?.message} />
        </MessageError>
      )

    if (isLoading) {
      return (
        <LoadingContainer>
          <ModalHeaderSkeleton />
          <SkeletonItem width={'100%'} height={'16px'} />
          <ContentInLine>
            <SkeletonItem width={'116px'} height={'16px'} />
            <SkeletonItem width={'204px'} height={'16px'} />
          </ContentInLine>
          <SkeletonItem width={'75%'} height={'16px'} />
          <SkeletonItem width={'92%'} height={'16px'} />
          <SkeletonItem width={'65%'} height={'16px'} />
          <ContainerBottom>
            <SkeletonItem width={'207px'} height={'24px'} />
          </ContainerBottom>
        </LoadingContainer>
      )
    }

    if (content) {
      return <ImagingTestDetailsContent imagingTestDetails={content} />
    }

    return <></>
  }

  return (
    <HealthProcedureDetails showModal={showModal} setShowModal={setShowModal} viewType="SideModal">
      <MainHealthProcedureDetailsContainer>{renderContent(imagingTest)}</MainHealthProcedureDetailsContainer>
    </HealthProcedureDetails>
  )
}
